
// Mainly for detecting "unload" state
// https://stackoverflow.com/a/15141116/838346

let unloaded: boolean = false

// Using umbrellajs for unload related event types would throw error like
// "Blocked a frame with origin "xxx" from accessing a cross-origin frame."
window.addEventListener("beforeunload", () => {
  unloaded = true
})

function isUnloaded(): boolean {
  return unloaded
}


export default {
  isUnloaded,
}
export {
  isUnloaded,
}
